<template>
  <v-app id="v-app" class="self-stretch">
    <v-form v-model="valid" class="join-us--form" ref="form" dark>
      <p class="intro font-semibold mt-8 mb-5">{{ translations.steps[3].form_title}}</p>
      <v-text-field
        dark
        :label="translations.steps[3].name"
        :rules="nameRules"
        v-model="name"
        filled
        rounded
        autocomplete="off"
      ></v-text-field>
      <div class="flex">
        <v-text-field
          dark
          class="w-1/2 pr-2"
          label="Email*"
          v-model="email"
          :rules="emailRules"
          filled
          rounded
          autocomplete="off"
        ></v-text-field>
        <v-text-field
          dark
          class="w-1/2 pl-2"
          :label="translations.steps[3].phone"
          :rules="phoneRules"
          v-model="phone"
          type="tel"
          filled
          rounded
          autocomplete="off"
        ></v-text-field>
      </div>
      <v-textarea label="Mensaje" :rules="textRules" filled rounded v-model="message"></v-textarea>

      <div class="flex justify-between items-center">
        <p
          class="w-5/12 mb-0 pr-4"
        >{{fileInput ? fileInput.name : 'CV/Resum'}}. {{fileInput ? fileInput.size : 0 }}bytes</p>
        <input
          type="file"
          class="custom-file-input"
          @change="onFileChange"
          name="document"
          id="file"
          ref="file"
          required
        />
        <div class="w-7/12 text-right">
          <label
            class="w-full mdc-button mdc-button--unelevated mdc-ripple-upgraded unelevated mdc-button--outlined"
            for="file"
          >
            <span class="mdc-button__label">{{ translations.steps[3].upload }}</span>
          </label>
        </div>
      </div>
       <div class="flex items-center mt-4 lg:mt-0 mb-2 privacy-container">
      <CheckboxVue
        id="privacy"
        :checked="checkboxChecked"
        @update:checked="checkboxChecked = $event"
      >
        <p class="ml-4">
          {{ translations.steps[3].agreeTextPart1 }}
          <a class="topaz" :href="translations.steps[3].privacyPolicyLink" target="_blank">{{ translations.steps[3].privacyPolicyText }}</a>
          {{ translations.steps[3].agreeTextPart2 }}
          <a class="topaz" :href="translations.steps[3].termsLink" target="_blank">{{ translations.steps[3].termsText }}</a>
        </p>
      </CheckboxVue>
      </div>
      <div class="flex items-center mt-2 lg:mt-0 privacy-container">
        <CheckboxVue
          id="privacy-commercial"
          :checked="checkboxCommercialChecked"
          @update:checked="checkboxCommercialChecked = $event"
        >
          <p class="ml-4">{{translations.steps[3].agreeComercial}}</p>
        </CheckboxVue>
      </div>

      <v-btn
        :disabled="!valid || fileInput == '' || !checkboxChecked "
        :loading="loading"
        @click="submitForm()"
        style="height: 45px"
        class="mt-5 mb-3 w-full mdc-button mdc-button--unelevated mdc-ripple-upgraded unelevated"
      >
        <span class="mdc-button__label">Enviar</span>
      </v-btn>
    </v-form>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="0">
      {{ this.snackText }}
      <v-btn color="white" text @click="snackbar = false">{{ translations.steps[3].close }}</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import axios from "axios";
import CheckboxVue from './Checkbox.vue';

export default {
  components: {
  CheckboxVue,
},
props: ["translations"],

  data() {
    return {
      lang: "",
      name: "",
      email: "",
      phone: "",
      message: "",
      valid: false,
      fileInput: "",
      loading: false,
      snackbarColor: "success",
      snackbar: "",
      snackText: "",
      checkboxChecked: false,
      checkboxCommercialChecked: false,
      emailRules: [
        v => !!v || this.translations.steps[3].emailRules[0],
        v => /.+@.+\..+/.test(v) || this.translations.steps[3].emailRules[1]
      ],
      phoneRules: [
        v => !!v || this.translations.steps[3].phoneRules[0],
        v => /^\d{9}$/.test(v) || this.translations.steps[3].phoneRules[1]
      ],
      nameRules: [v => !!v || this.translations.steps[3].nameSurname],
      textRules: [v => !!v || this.translations.steps[3].text],
    };
  },
  methods: {
    onFileChange(e) {
      this.fileInput = this.$refs.file.files[0];
    },
    submitForm() {
      this.loading = true;
      let formData = new FormData();
      formData.append("file", this.fileInput);
      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("phone", this.phone);
      formData.append("message", this.message);

      axios
        .post("/job-form", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          },
          locale: this.locale,
        })
        .then(res => {
          this.loading = false;
          this.$refs.form.reset();
          this.snackText = this.translations.steps[3].sent;
           this.snackbarColor = "success";
          this.snackbar = true;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.snackbarColor = "info";
          this.snackText = this.translations.steps[3].error;
          this.snackbar = true;
        });
    }
  },

  created() {
    this.lang = window.appLocale
  }
};
</script>

<style lang="scss" scoped>
.custom-file-input {
  position: absolute;
  height: 45px;
  z-index: 5;
  width: 100%;
  max-width: 30px;
  opacity: 0;
}

</style>
